module.exports = __webpack_public_path__ + "static/media/image2.71eccb8a.png";